document.addEventListener("DOMContentLoaded", () => {

  // ─── Mobile menu ─────────────────────────────────────────────────────────
  const burger = document.querySelector(".js-burger");
  const menu   = document.querySelector(".js-header-nav");
  if (burger && menu) {
    const toggleMenu = () => {
      const open = menu.classList.toggle("active");
      burger.classList.toggle("active", open);
      document.body.classList.toggle("locked", open);
    };
    burger.addEventListener("click", toggleMenu);
    burger.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        toggleMenu();
      }
    });
    window.addEventListener("resize", () => {
      if (window.innerWidth > 992) {
        menu.classList.remove("active");
        burger.classList.remove("active");
        document.body.classList.remove("locked");
      }
    });
  }

  // ─── Search overlay ───────────────────────────────────────────────────────
  const openSearchBtn  = document.querySelector(".js-open-search");
  const closeSearchBtn = document.querySelector(".js-close-search");
  const searchOverlay  = document.querySelector(".js-search-overlay");
  if (openSearchBtn && closeSearchBtn && searchOverlay) {
    openSearchBtn.addEventListener("click", (e) => {
      e.preventDefault();
      searchOverlay.classList.add("active");
      document.body.classList.add("locked");
      setTimeout(() => {
        const input = searchOverlay.querySelector("input");
        if (input) input.focus();
      }, 100);
    });
    closeSearchBtn.addEventListener("click", () => {
      searchOverlay.classList.remove("active");
      document.body.classList.remove("locked");
    });
    searchOverlay.addEventListener("click", (e) => {
      if (e.target === searchOverlay) {
        searchOverlay.classList.remove("active");
        document.body.classList.remove("locked");
      }
    });
  }

  // ─── Header clock ──────────────────────────────────────────────────────────
  const clock = document.querySelector(".js-clock");
  if (clock) {
    const tick = () => {
      clock.textContent = new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
    };
    tick();
    setInterval(tick, 30000);
  }

  // ─── Back to top ─────────────────────────────────────────────────────────
  const backToTop = document.querySelector(".js-back-to-top");
  if (backToTop) {
    const toggle = () => backToTop.classList.toggle("is-visible", window.scrollY > 400);
    window.addEventListener("scroll", toggle, { passive: true });
    toggle();
    backToTop.addEventListener("click", () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  }

});
